import classNames from 'classnames';

import '~/shared/components/price/price.scss';

export type PricePropsType = {
  price: number;
  invertColors?: boolean;
  t: (key: string, options: { ns: string[] }) => string;
};

const Price = ({ price, t, invertColors = false }: PricePropsType) => (
  <div className="price">
    <span
      className={classNames('price__text', {
        'price__text--invert': invertColors,
      })}
    >
      {t('text.price-of-course')}
    </span>
    <div className="price__price-block">
      <span className="price__count">{price}</span>
      <span
        className={classNames('price__currency', {
          'price__currency--invert': invertColors,
        })}
      >
        {t('text.uah')}
      </span>
    </div>
  </div>
);

export default Price;
